angular
  .module('app')
  .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/be/');

  $stateProvider
    .state('serverErrors', {
      url: '/be/serverErrors',
      component: 'serverErrors'
    })
    .state('booking', {
      abstract: true,
      url: '/be/{language:[a-zA-Z]{2}}/{userHash:[0-9]{1,32}}/{hotelId:(?:[a-fA-F0-9]{8}(?:-[a-fA-F0-9]{4}){3}-[a-fA-F0-9]{12})}',
      component: 'bookingEngine',
      resolve: {
        hotelConfig: function (SettingService, $stateParams) {
          return SettingService.getHotelConfig($stateParams.userHash, $stateParams.hotelId, $stateParams.language);
        },
        bookingEngineConfig: function (ENV, $q, $window, SettingService, $stateParams) {

          var deferred = $q.defer();
          SettingService.getBookingEngineConfig($stateParams.userHash, $stateParams.hotelId, $stateParams.language).then(function (beConfig) {
            deferred.resolve(beConfig);

            if (beConfig.redirect_to_gs) {
              if ($stateParams.checkIn && $stateParams.checkOut) {
                var searchParams = 'arrivalDate=' + $stateParams.checkIn + '&departureDate=' + $stateParams.checkOut + '&personsCount=2&ageCategoryCounts=[]&rooms=[]';

                if ($stateParams.featuredRateplanId) {
                  searchParams += '&featuredRatePlanId=' + $stateParams.featuredRateplanId;
                }

                if ($stateParams.featuredRoomGroupId) {
                  searchParams += '&featuredRoomTypeId=' + $stateParams.featuredRoomGroupId;
                }

                $window.location.href = ENV.begs + $stateParams.language + '/' + $stateParams.hotelId + '/offers?' + searchParams;
              } else {
                $window.location.href = ENV.begs + $stateParams.language + '/' + $stateParams.hotelId + '/offers';
              }
            }
          })
          return deferred.promise;
        },
        categoriesList: function (SettingService, $stateParams) {
          return SettingService.getCategoriesList($stateParams.userHash, $stateParams.hotelId, $stateParams.language);
        },
        roomGroupCategoryFiltersList: function (SettingService, $stateParams) {
          return SettingService.getRoomGroupCategoryFilters($stateParams.hotelId);
        },
        customerCss: function (SettingService, $stateParams) {
          return SettingService.getCustomerCss($stateParams.userHash, $stateParams.hotelId);
        }
      }
    })
    .state('booking.clientErrors', {
      url: '/clientErrors?code',
      component: 'clientErrors',
      resolve: {
        code: function ($stateParams) {
          return $stateParams.code;
        }
      }
    })
    .state('booking.offers', {
      url: '?checkIn&checkOut&occupancy&roomGroupCategoryFilterId&categoryId&discountCode&roomGroupId&rateplanId&featuredRoomGroupId&featuredRateplanId&viewType&consent',
      component: 'offers'
    })
    .state('booking.addons', {
      url: '/addons?checkIn&checkOut&occupancy&cart&discountCode&viewType&addons&consent',
      component: 'addons'
    })
    .state('booking.guest', {
      url: '/step2?checkIn&checkOut&occupancy&cart&discountCode&viewType&addons&consent',
      component: 'guest'
    })
    .state('booking.payment-status', {
      url: '/payment-status?token',
      component: 'paymentStatus'
    })
    .state('booking.payment-redirect', {
      url: '/payment-redirect',
      component: 'paymentRedirect'
    });
}
